


























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetPatientInfo, GetPatientPartDetail } from "@/request/hdr";
import {
  GetHospitalsOfUserInCenter,
  GetCenter,
  ImportPatientToCenter
} from "@/request/idr";
import Copy from "@/components/copy.vue";
import DetailHeader from "./detail-header.vue";
import DetailLeftNav from "./detail-left-nav.vue";
import Gerenxinxi from "./details/gerenxinxi.vue";
import SheJichu from "./details/shexiang.vue";
import SheKeyan from "./details/shexiang-keyan/shexiang-keyan.vue";
import Shetubaogao from "./details/shetubaogao/shetubaogao.vue";
import Mian from "./details/mianxiang/mianxiang.vue";
import Mai from "./details/maixiang/maixiang.vue";
import Toufa from "./details/toufa/toufa.vue";
import Shou from "./details/shou/shou.vue";
@Component({
  components: {
    Copy,
    DetailHeader,
    DetailLeftNav,
    Gerenxinxi,
    SheJichu,
    SheKeyan,
    Shetubaogao,
    Mian,
    Mai,
    Toufa,
    Shou
  }
})
export default class IdrPatientDetail extends Vue {
  private patient: any = {};
  private cState: any = "个人信息";
  private message: any = {};
  private loaded: boolean = false;
  private ifShowFill: boolean = false;
  private fillParams: any = {
    center: {},
    project_id: "",
    hospital_id: ""
  };
  private centers: any[] = [];
  private hospitals: any[] = [];
  @Watch("$route.query", { immediate: true })
  private queryChange(query: any) {
    if (query.patient_id && query.part) {
      this.cState = query.part;
      this.patient.patient_id = query.patient_id;
      this.fetchPatientPartDetail();
    }
  }

  /**
   * @description 获得患者基本信息
   */
  private fetchPatient() {
    GetPatientInfo(this, this.patient.patient_id).then((data: any) => {
      this.patient = data;
    });
  }
  /**
   * @description 获得患者某部分信息
   */
  private fetchPatientPartDetail() {
    this.loaded = false;
    GetPatientPartDetail(this, this.patient.patient_id, this.cState).then(
      (data: any) => {
        this.message = data;
        this.loaded = true;
      }
    );
  }
  /**
   * @description 处理状态变化
   */
  private handleStateChange(state) {
    this.cState = state;
  }
  /**
   * @description 开始填充
   */
  private fill() {
    this.fetchCenters().then(() => {
      this.fetchHospitals();
    });
    this.ifShowFill = true;
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchCenters() {
    return new Promise((resolve, reject) => {
      GetCenter(this).then((data: any) => {
        this.centers = data;
        this.fillParams.center = this.centers[0];
        resolve();
      });
    });
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    this.fillParams.hospital_id = "";
    const params: any = {
      params: {
        project_id: this.fillParams.center.project_id
      }
    };
    GetHospitalsOfUserInCenter(this, params).then((data: any) => {
      this.hospitals = data;
      this.fillParams.hospital_id = this.hospitals[0].hospital_id;
    });
  }
  /**
   * @description 确定补充
   */
  private startFill() {
    const params: any = {
      src_center: "中医影像数据中心",
      hpt_id: this.patient.hpt_id,
      project_id: this.fillParams.center.project_id,
      group_id: this.fillParams.center.group_id,
      hospital_id: this.fillParams.hospital_id
    };
    ImportPatientToCenter(this, params).then((data: any) => {
      this.$message.success("导入成功");
      let path: any = "";
      switch (this.fillParams["center"]["center"]) {
        case "名中医传承数据中心":
          path = "/main/edr/patient-detail";
          break;
        case "临床科室数据中心":
          path = "/main/cdr/patient-detail";
          break;
      }
      this.$router.push({
        path,
        query: {
          patient_id: this.patient.patient_id,
          project_id: this.fillParams.center.project_id,
          group_id: this.fillParams.center.group_id
        }
      });
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.patient.patient_id = this.$route.query.patient_id;
    this.cState = this.$route.query.part ? this.$route.query.part : "个人信息";
    this.fetchPatient();
    this.fetchPatientPartDetail();
  }
}
